// NPM imports
import React, { Component, Suspense } from "react";
import { connect } from "react-redux";

// Action imports
import {
  changeToolsView,
  getClausesForDealTable,
  reOrderDocumentSectionList,
} from "../../actions/DocumentActions";

import NotesActions from "../../actions/NotesActions";

// Import services
import {
  addDocumentComponentService,
  deleteDocumentComponentService,
  updateDocumentComponentService,
  updateDocumentOrder,
} from "../../actions/DocumentActions/services";
// Import utils
import { checkAcceptRejectNotes } from "../../utils/documentUtils";

// Components Imports
import { LazyLoad } from "../../commonComponents";

const DocumentLazy = LazyLoad(() =>
  import(/* webpackChunkName: "document" */ "../Document"),
);

const { addNote } = NotesActions;

// Components Imports
class DocumentWrapper extends Component {
  state = {};

  componentDidMount() {
    const { dealTable, isSharedDocument } = this.props;
    // Need to remove "isSharedDocument" later
    if (
      !isSharedDocument &&
      dealTable !== null &&
      dealTable !== undefined &&
      dealTable.id !== undefined
    ) {
      this.props.getClausesForDealTable(dealTable.id);
    }
    if (this.props.acceptRejectChanges) {
      this.props.changeToolsView("notes");
    }
  }

  componentDidUpdate(prevProps) {
    const { dealTable, isSharedDocument } = this.props;
    // Need to remove "isSharedDocument" later
    if (
      !isSharedDocument &&
      dealTable !== prevProps.dealTable &&
      dealTable !== null &&
      dealTable !== undefined &&
      dealTable.id !== undefined
    ) {
      this.props.getClausesForDealTable(dealTable.id);
    }
  }

  _addNote = note => {
    this.props.addNote(note);
    this.props.changeToolsView("notes");
  };

  render() {
    return (
      <Suspense fallback="">
        <DocumentLazy
          mode={this.props.mode}
          addNote={this._addNote}
          sharingHash={this.props.sharingHash}
          isLocked={this.props.isLocked || this.props.acceptRejectChanges}
          addNewSectionService={addDocumentComponentService}
          deleteSectionService={deleteDocumentComponentService}
          updateSectionService={updateDocumentComponentService}
          reOrderSectionListAction={this.props.reOrderSectionListAction}
          reOrderSectionListService={updateDocumentOrder}
          isSharedDocument={this.props.isSharedDocument}
          signatureWrapperRef={this.props.signatureWrapperRef}
          isSharedDocumentPerma={this.props.isSharedDocumentPerma}
          masterDocumentName={this.props.masterDocumentName}
          toggleThankyouPopUp={this.props.toggleThankyouPopUp}
        />
      </Suspense>
    );
  }
}

const mapStateToProps = state => {
  const { document } = state.DocumentStore;
  const { dealTable, isLocked } = document;
  const { documentNotes } = state.NotesStore;
  const acceptRejectChanges = checkAcceptRejectNotes(documentNotes);

  return {
    acceptRejectChanges,
    dealTable,
    isLocked,
  };
};

const mapDispatchToProps = {
  addNote,
  changeToolsView,
  reOrderSectionListAction: reOrderDocumentSectionList,
  getClausesForDealTable,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentWrapper);
